@if(tag().tagTranslatedList.length > 0){
<div class="container-md">
  @if(logoFileNameView() == null || title() == '' ||
  description() == ''){
  <fa-icon class="me-2" [icon]="faTags"></fa-icon>
  <span class="fw-bold">{{ "IDS_TAG_RESULTS" | translate }}</span>
  @if(tagNameToShow() != ''){
  <span class="ms-2 my-3 searchTerm">"{{ tagNameToShow() }}"</span>
  } }
</div>
}
@if(logoFileNameView() != ''){
<div class="mb-3">
  <img
    class="img-slideshow"
    [src]="logoFileNameView() + '?w=1920'"
    alt="tag slideshow"
  />
</div>
}
@if(!!tagTranslated()){
<div class="container-md">
  @if(title()){
    <div class="row my-4">
      <div class="col-12 title">
        <h1>{{ title() }}</h1>
      </div>
    </div>
  }

  @if(description()){
  <div class="row my-4">
    <div class="col-12">
      <div
        class="static-page"
        [innerHTML]="description()"
      ></div>
    </div>
  </div>}
</div>
}
<div class="main-container">
  <div class="container-md">
    @if(isLoaded()) {
      <app-bid-search-result
        [memorabidAuctions]="auctionDownloadedService.memorabidAuctions"
        [marketplaceAuctions]="auctionDownloadedService.marketplaceAuctions"
        [isBidBoxLarge]="true"
        [idAuctionList]="idAuctionList()"
        (auctionStatusFilterChanged)="onAuctionStatusFilterChanged($event)"
      />
    }
  </div>
</div>
